import { formatMoney } from '@erp/shared';

import { Link } from 'react-router';

import { priceLabel, useOwnedProperties } from '../../lib/properties-api.ts';
import { StatusBadge } from '../properties/badges.tsx';
import { Card } from '../ui/card.tsx';

/** HU-CON-07: an owner's properties with status, price, days on the market and agent. */
export function OwnedPropertiesCard({ contactId }: { contactId: string }) {
  const owned = useOwnedProperties(contactId);
  const items = owned.data?.items ?? [];
  const hidden = owned.data?.hiddenCount ?? 0;
  if (items.length === 0 && hidden === 0) return null;
  return (
    <Card className="space-y-3">
      <h2 className="font-semibold">Propiedades como propietario</h2>
      <ul className="divide-y divide-border text-sm">
        {items.map((p) => (
          <li key={p.id} className="space-y-1 py-2">
            <div className="flex flex-wrap items-baseline justify-between gap-2">
              <Link
                to={`/propiedades/${p.id}`}
                className="font-medium text-primary hover:underline"
              >
                {p.title}
              </Link>
              <span className="tabular-nums">{priceLabel(p, (n) => formatMoney(n))}</span>
            </div>
            <div className="flex flex-wrap items-center gap-1.5 text-xs text-muted-foreground">
              <span className="font-mono">{p.code}</span>
              <StatusBadge status={p.status} />
              {p.daysOnMarket !== null && (
                <span>
                  · {p.daysOnMarket} {p.daysOnMarket === 1 ? 'día' : 'días'} publicada
                </span>
              )}
              <span>· {p.assignedTo}</span>
            </div>
          </li>
        ))}
      </ul>
      {hidden > 0 && (
        <p className="text-xs text-muted-foreground">
          {hidden === 1
            ? 'Otra propiedad suya está a cargo de alguien fuera de tu cartera.'
            : `Otras ${String(hidden)} propiedades suyas están a cargo de personas fuera de tu cartera.`}
        </p>
      )}
    </Card>
  );
}
